import { View, Button } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { Divider } from "@/components/shared/divider";

export type OurPayNowDetailProps = {
  uenNumber: string;
  invoiceId: string;
  onCopyUenNumber: () => void;
  onCopyReference: () => void;
  children?: React.ReactNode;
};

export const OurPayNowDetail = ({
  uenNumber,
  invoiceId,
  onCopyUenNumber,
  onCopyReference,
  children,
}: OurPayNowDetailProps) => (
  <View className="flex flex-col gap-2 rounded-lg bg-white px-6 py-4">
    <Typography variant="label-md" className="mb-2">
      Our PayNow Details
    </Typography>
    <View className="flex flex-row items-center justify-between gap-2">
      <View className="flex flex-col gap-2">
        <Typography variant="body-sm" color="foreground-intermediate">
          PayNow UEN
        </Typography>
        <Typography variant="label-sm">{uenNumber}</Typography>
      </View>
      <Button
        variant="tertiary"
        size="md"
        iconName="copy"
        iconSize="lg"
        color="CTA2"
        iconColor="CTA2"
        iconAlignment="start"
        onClick={onCopyUenNumber}
      >
        Copy
      </Button>
    </View>
    <Divider className="my-2" />
    <View className="flex flex-row items-center justify-between gap-2">
      <View className="flex flex-col gap-2">
        <Typography variant="body-sm" color="foreground-intermediate">
          Reference
        </Typography>
        <Typography variant="label-sm">{`P${invoiceId}`}</Typography>
      </View>
      <Button
        variant="tertiary"
        size="md"
        iconName="copy"
        iconSize="lg"
        color="CTA2"
        iconColor="CTA2"
        iconAlignment="start"
        onClick={onCopyReference}
      >
        Copy
      </Button>
    </View>
    {children}
  </View>
);
